import * as classnames from 'classnames';
import * as React from 'react';

import { FormattedMessage } from 'react-intl';
import { change, WrappedFieldProps } from 'redux-form';

import './InputOtp.scss';

export interface InputOtpProps {
  className?: string;
  disabled?: boolean;
  onComplete: MSExecAtPriorityFunctionCallback;
}

export class InputOtp extends React.Component<InputOtpProps & WrappedFieldProps, {}> {
  private input: HTMLInputElement[] = [];
  private inputTotal = 6;

  focus() {
    const firstIndex = 0;
    return this.input[firstIndex].focus();
  }

  render() {
    const { className, meta } = this.props;
    const classNameError = meta.touched && meta.error && 'input-otp__footnote--is-error';
    return (
      <div className={classnames('input-otp__container', className)}>

        {this.inputHtml}

        <p className={classnames('input-otp__footnote', classNameError)}>
          {meta.touched && meta.error && <span><FormattedMessage id={meta.error}/></span>}
        </p>
      </div>
    );
  }

  get value() {
    return this.input.map((htmlInputElement: HTMLInputElement) => htmlInputElement.value).join('').toUpperCase();
  }

  private get inputHtml() {
    const { disabled, meta } = this.props;
    const inputs: JSX.Element[] = [];
    const classNameError = meta.touched && meta.error && 'input-otp__element--is-error';
    for (let index = 0; index < this.inputTotal; index++) {
      inputs.push(
        <input
          className={classnames('input-otp__element', classNameError)}
          type="number"
          min="0"
          max="9"
          autoComplete="off"
          disabled={disabled}
          key={index}
          onChange={this.onChange.bind(this, index)}
          onFocus={this.onFocus.bind(this, index)}
          onKeyDown={this.onKeyDown.bind(this, index)}
          ref={this.setReference.bind(this, index)}
        />
      );
    }
    return inputs;
  }

  private isAllInputValid(): boolean {
    return this.input.every((htmlInputElement: HTMLInputElement) => !!htmlInputElement.value);
  }

  private onChange(index: number, event: React.ChangeEvent<HTMLInputElement>) {
    if (!this.isValidValue(this.input[index].value)) {
      this.input[index].value = '';
    }

    if (this.input[index].value.length > 1) {
      this.input[index].value = this.input[index].value.slice(0, 1);
    }

    const { input, meta, onComplete } = this.props;
    if (this.isAllInputValid()) {
      meta.dispatch(change(meta.form, input.name, this.value));
      if (onComplete) {
        setTimeout(() => onComplete(), 0);
      }
    } else {
      meta.dispatch(change(meta.form, input.name, ''));
    }

    if (this.isValidValue(this.input[index].value)) {
      this.setNextInputFocus(index);
    }
  }

  private onFocus(indexOfInput: number) {
    for (let index = 0; index < indexOfInput; index++) {
      if (!this.input[index].value) {
        this.input[index].focus();
        break;
      }
    }
  }

  private onKeyDown(index: number, event: KeyboardEvent) {
    const key = event.keyCode || event.charCode;
    const previousIndex = index - 1;
    const backspaceKey = 8;

    if (key === backspaceKey && !this.input[index].value && this.input[previousIndex]) {
      this.input[previousIndex].value = '';
      this.input[previousIndex].focus();
    }
  }

  private isValidValue(value: string) {
    const regExp = /[0-9]/;
    return regExp.test(value);
  }

  private setNextInputFocus(currentIndex: number) {
    const index = currentIndex + 1;
    if (this.input[index]) {
      this.input[index].focus();
    }
  }

  private setReference(index: number, htmlInputElement: HTMLInputElement) {
    if (htmlInputElement && !this.input[index]) {
      this.input.push(htmlInputElement);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputOtp/InputOtp.tsx